module.exports = __webpack_public_path__ + "img/gauge-simple-min.ea895ac8.svg";